export default __webpack_public_path__ + "static/media/company-name.bb05708d.png";